import debounce from 'lodash.debounce';

interface FixedHeaderProps {
    el: HTMLDivElement;
}

const FIXED_HEADER_CLASS = 'fixed-header';
const HEADER_FIXED_CLASS = 'header-fixed';
const HEADER_FIXED_SHOW_CLASS = 'header-fixed-show';
const HEADER_FIXED_HIDE_CLASS = 'header-fixed-hide';
const DEBOUNCE_VALUE = 10;

const FixedHeader = ({ el }: FixedHeaderProps): void => {
    el.classList.add(FIXED_HEADER_CLASS);
    let prevScrollY = window.pageYOffset;

    const hideFixedHeader = (): void => {
        el.classList.remove(HEADER_FIXED_SHOW_CLASS);
        el.classList.add(HEADER_FIXED_CLASS, HEADER_FIXED_HIDE_CLASS);
    };

    const showFixedHeader = (): void => {
        el.classList.remove(HEADER_FIXED_HIDE_CLASS);
        el.classList.add(HEADER_FIXED_CLASS, HEADER_FIXED_SHOW_CLASS);
    };

    const cleanFixedHeader = (): void => {
        el.classList.remove(
            HEADER_FIXED_CLASS, HEADER_FIXED_SHOW_CLASS, HEADER_FIXED_HIDE_CLASS
        );
    };

    const applyFixedHeader = (): void => {
        el.classList.add(HEADER_FIXED_CLASS);
    };

    const windowScrollCheck = (): void => {
        const elHeight = el.offsetHeight;
        const alertBanner = document.querySelector('.alert-banner');
        const alertBannerHeight = alertBanner ? (alertBanner as HTMLDivElement).offsetHeight : 0;
        const headerHeight = el.parentElement ? el.parentElement.offsetHeight + alertBannerHeight : elHeight + alertBannerHeight;
        const subHeaderHeight = headerHeight - elHeight;
        const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;

        // if on top of the page
        if (currentScrollY <= headerHeight) {
            // If on top of the page, change back to absolute position
            // Depend on your needs position can be changed
            if (currentScrollY <= subHeaderHeight) {
                cleanFixedHeader();
            }
            // If more than header height and scroll up
        } else if (currentScrollY < prevScrollY) {
            showFixedHeader();
            // If more than header height and scroll down
        } else if (currentScrollY !== prevScrollY) {
            const isFixed = el.classList.contains('header-fixed');
            const isFixedShow = el.classList.contains('header-fixed-show');
            const isFixedHide = el.classList.contains('header-fixed-hide');

            // if after header is shown on fixed state
            if (isFixed && isFixedShow) {
                hideFixedHeader();
                // if from absolute then apply fixed position
            } else if (!isFixed && !isFixedHide) {
                applyFixedHeader();
            }
        }

        prevScrollY = currentScrollY;
    };

    windowScrollCheck();

    window.addEventListener('resize', debounce(windowScrollCheck, DEBOUNCE_VALUE));
    window.addEventListener('scroll', debounce(windowScrollCheck, DEBOUNCE_VALUE));
};

export default FixedHeader;
